module.exports = __webpack_public_path__ + "assets/img/user-avatar.24740701.png";